import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'seo-suppliers_page_most_popular_carousel-view';

/**
 * track most popular brands carousel view on suppliers page
 */
export function trackSeoSuppliersPageMostPopularCarouselView(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
